import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationStateService } from '../services/translation-state.service';

@Pipe({ name: 'i18nCurrency', standalone: true, pure: false })
export class I18nCurrencyPipe implements PipeTransform {
  private translationStateService = inject(TranslationStateService);
  transform(
    value: number | string | null | undefined,
    currency?: string,
    options?: Intl.NumberFormatOptions
  ) {
    const locale = this.translationStateService.locale();
    const code = currency ?? (locale.startsWith('pt') ? 'BRL' : 'USD');
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      ...options,
    });
    return value == null ? '' : formatter.format(+value);
  }
}